import React, {Component} from 'react'
import logoImg from './dangerLogo.jpg'
import {Modal, Button} from 'antd'

export default function ContractModal(props) {
    const handleCancel = () => {
        props.onCancel();
    };
    return <Modal title='呜呜网国内车货物规范协议'
                  visible={props.view}
                  onCancel={handleCancel}
                  width='810px'
                  footer={[<Button key="back" onClick={handleCancel}>关闭</Button>]}>
        <div className="contract-box ">
            <div className="title">呜呜网国内车货物规范协议</div>
            <div className="t-name">尊敬的呜呜网平台用户：</div>
            <div className="t-text">
                <p>欢迎您使用呜呜网平台及国内车运输服务。</p>
                <p>为正常使用呜呜网平台及服务，保护您的合法权益，规范管理秩序，保障道路运输安全，请务必审慎阅读、充分理解各条款内容。除非您已阅读并接受本协议所有条款，否则无权继续使用呜呜网平台及相关服务。</p>
                <p>根据相关规范性法律法规文件，呜呜网针对用户通过平台下单托运的货物进行如下规范：</p>
                <p>1、托运人通过呜呜网下单时应确认并保证其托运的货物符合《中华人民共和国道路运输条例》等相关规范性法律文件的规定，不包含任何危险品、违禁品、任何形式的赃物、无证明文件的限运货物（具体见附件）。</p>
                <p>2、托运的货物应当符合核定的载重量，严禁超载，载物的长、宽、高不得违反车辆装载要求。</p>
                <p>3、托运人在下单时填写的货物名称应当明确具体，不得过于模糊或包含标点符号、数字及其他与货物名称无关的文字(不得填写普货、泡货、托盘货等）。</p>
                <p>托运人知晓并同意禁止托运危险品、违禁品、赃物及限运货物为使用呜呜网平台服务的前提。如您所托运的货物含有上述物品，请立即停止使用本平台及服务。</p>
                <p>违法运输可能构成犯罪，面临刑事责任。如您违反规定，下单托运了危险品、违禁品、赃物或不能提供证明文件的限运货物，则国家机关可能会对您提出诉讼、罚款或采取其他法律措施，您应该自行承担相应法律责任。为了保障您的合法权益，请您按照上述规范的要求托运货物。</p>
                <p>如您与呜呜网之间关于本协议内容发生任何争议及纠纷，首先应友好协商解决；协商不成的，呜呜网以及您同意将纠纷提交到霍尔果斯仲裁委员会仲裁解决。</p>
                <hr/>
                <div className="h1"><strong>附件： 危险品、违禁品、赃物及限运货物说明</strong></div>
                <div className="h1"><strong>一、危险品</strong></div>
                <p>是指具有爆炸、易燃、毒害、感染、腐蚀、放射性等危险特性，在运输、储存、生产、经营、使用和处置中，容易造成人身伤亡、财产损毁或环境污染而需要特别防护的物质和物品。具体类目以《危险货物品名表》
                    (GB12268）以及相关法律法规规定为准。包括但不限于：</p>
                <p>1、爆炸品</p>
                <p>指在外界作用下(如受热、受压、撞击等），能发生剧烈的化学反应，瞬间产生大量的气体和热量，使周围压力急骤上升，发生爆炸，对周围环节造成破坏的物品，也包括无整体爆炸危险，但具有燃烧、抛射及较小爆炸危险，或仅产生热、光、音响或烟雾等一种或几种作用的物品。如：</p>
                <p>爆破器材：如炸药、雷管。导火索、导爆索、爆破剂等。</p>
                <p>烟花爆竹：如烟花、鞭炮、摔炮、拉炮、砸炮、彩药弹等烟花爆竹及黑火药、烟火药、发令纸、引火线等。</p>
                <p>其他：如推进剂、发射药、硝化棉、电点火头、灭火器、樟脑油、煤油等。</p>
                <p>2、易燃物品、压缩和液化气体及其容器、易燃液体</p>
                <p>2.1易燃物品</p>
                <p>易燃固体：指燃点低、对热、撞击、经摩擦后，极易引起剧烈燃烧，并可能散发出有毒烟雾或有毒气体的固体。如红磷、硫磺、铝粉、闪光粉、固体酒精、火柴、活性炭、干柴、鱼粉、摄影闪光弹等。</p>
                <p>自燃物品：指自燃点低，在外界无火源存在时，由于氧化等原因，放出热量，而自行燃烧的物品。如黄磷、白磷、硝化纤维(含胶片)、钛粉等。</p>
                <p>遇水易燃物质：指遇水或受潮时，发生剧烈化学反应，放出大量的易燃气体和热量的物品。有些不需明火，即能燃烧或爆炸。如金属钠、钾、锂、锌粉、镁粉、碳化钙（电石）、氰化钠、氰化钾等。</p>
                <p>2.2压缩和液化气体</p>
                <p>易爆或者室息、助燃气体：如压缩氧气、氮气、氦气、氖气、气雾等</p>
                <p>易燃气体：如氢气、甲烷、乙烷、丁烷、天然气、液化石油气、乙烯、丙烯、乙炔、打火机等。</p>
                <p>2.3易燃液体指易于挥发和燃烧的液态物质</p>
                <p>如汽油、煤油、苯、乙醚、甲醇（木醇或木精）、乙醇（酒精)、松节油等。</p>
                <p>3、有毒物品</p>
                <p>有毒气体：该类气体有毒对人畜有强烈的毒害、室息、灼伤、刺激作用。如二氧化硫、一氧化碳、氯气、气体杀虫剂、一氧化氮等。</p>
                <p>毒性物质：经口：LD50{'<'}500mg/kg(固体)，LD50≤2000mg/kg(液体)；经皮：LD50≤1000mg/kg(24h接触)；</p>
                <p>吸入：LC50≤10mg/L(粉尘、烟雾、蒸气)。如砷、砒霜、汞化物、铊化物、氰化物、硒粉、苯酚、汞、剧毒农药、药物等。</p>
                <p>感染性物质：指含有致病的微生物，能引起病态，甚至死亡的物质。如病菌、炭疽、寄生虫、排泄物、医疗废弃物等。</p>
                <p>4、氧化剂和有机过氧化物</p>
                <p>氧化剂：指处于高氧化态，具有强氧化性，易分解并放出氧和热量的物质。包括含有过氧基的有机物，其本身不一定可燃，但能导致可燃物的燃烧，与松软的粉末状可燃物能组成爆炸性混合物，对热、震动或摩擦较为敏感。</p>
                <p>有机过氧化物：指分子组成中含有过氧基的有机物，其本身易燃易爆、极易分解，对热、震动和摩擦极为敏感。如高锰酸盐、高氯酸盐、氧化氢、过氧化钠、过氧化钾、过氧化铅、氯酸盐、溴酸盐、硝酸盐、双氧水等。</p>
                <p>5、放射性物品</p>
                <p>指放射性比活度大于7.4×10Bq/g的物品，具有放射性（如α射线，也叫甲种射线；B射线，也叫乙种射线；y射线，也叫丙种射线；还有中子流)。如铀、钴、镭、钚等。</p>
                <p>6、腐蚀品</p>
                <p>指能灼伤人体组织并对金属等物品造成损坏的固体或液体，与皮肤接触在4小时内出现可见坏死现象，或温度在55C时，对20号钢的表面均匀年腐蚀超过6.25mm的固体或液体。腐蚀品包括但不限于以下物品：如硫酸、硝酸、盐酸、蓄电池（组）、涂料（油漆)、染料、氢氧化钠、氢氧化钾等。</p>
                <div className="h1"><strong>二、违禁品</strong></div>
                <p>除危险货物以外，按照国家规定禁止运输或受严格管制、限制的物品。例如：</p>
                <p>1、枪支（含仿制品、主要零部件）弹药枪支（含仿制品、主要零部件）：如手枪、步枪、冲锋枪、防暴枪、气枪、猎枪、运动枪、麻醉注射枪、钢珠枪、催泪枪等。</p>
                <p>弹药（含仿制品)：如子弹、炸弹、手榴弹、火箭弹、照明弹、燃烧弹、烟幕（雾）弹、信号弹、催泪弹、毒气弹、地雷、手雷、炮弹、火药等。</p>
                <p>2、管制刀具类</p>
                <p>七首、三棱刀、三棱刮刀、半圆刮刀、侵刀、扒皮刀、羊骨刀、猎刀、弹簧刀、单刃及双刃尖刀（刀体八厘米以上，带自锁装置或非折叠式)、武术用刀（能开刃的）、武术用剑（能开刃的）、少数民族用的藏刀、腰刀、靴刀、弓、弩等。</p>
                <p>3、毒品、吸毒工具、非正当用途麻醉药品和精神药品、非正当用途的易制毒化学品。</p>
                <p>毒品：如鸦片（包括罂粟壳、花、苞、叶）、吗啡、海洛因、可卡因、大麻、甲基苯丙胺（冰毒）、氯胺酮、甲卡西酮、苯丙胺、安钠咖等。</p>
                <p>易制毒化学品：如胡椒醛、黄樟素、黄樟油、麻黄素、伪麻黄素、羟亚胺、邻酮、苯乙酸、溴代苯丙酮、醋酸酐、甲苯、丙酮等。</p>
                <p>吸毒工具：如冰壶等。</p>
                <p>4、麻醉药品类：如阿片粉、复方桔梗散、阿片酊、盐酸吗啡注射液、盐酸乙基吗啡、盐酸罂粟碱、福尔可定及其片剂、盐酸可卡因、全阿片素、大麻浸膏、杜冷丁注射液、杜冷丁片、安侬痛注射液、枸椽酸芬太尼注射液、美散痛注射液、美散痛片、曲马多等。</p>
                <p>5、非法伪造物品：如伪造或者变造的货币、证件、公章等。</p>
                <p>6、非法出版物、印刷品、音像制品等宣传品：如含有反动、煽动民族仇恨、破坏国家统一、破坏社会稳定、宣扬邪教、宗教极端思想、淫秽等内容的图书、刊物、图片、照片、音像制品等。</p>
                <p>7、侵犯知识产权和假冒伪劣物品：侵犯知识产权：如侵犯专利权、商标权、著作权的图书、音像制品等。</p>
                <p>假冒伪劣：如假冒伪劣的食品、药品、儿童用品等。</p>
                <p>8、濒危野生动物及其制品：如象牙、虎骨、犀牛角及其制品等。</p>
                <div className="h1"><strong>三、赃物</strong></div>
                <p>指违法犯罪所得的各种形式的货物，包括普通货物以及其他货物。</p>
                <div className="h1"><strong>四、限运货物</strong></div>
                <p>依据相关规范性法律文件，部分货物需提供一定证明文件方可运输，包括但不限于：</p>
                <p>1、影视类：如光盘、影碟、音像制品、母碟等。必须具有当地社会文化管理委员会办公室颁发的《音像制品运输传递证明》及《货物清单》，相关材料/手续由运输服务需求方自行办理并提供。</p>
                <p>2、植物及植物产品：托运植物及植物产品应当经过检疫，取得《植物检疫证书》后方可托运。需经检疫的植物及植物产品包括但不限于：</p>
                <p>(1) 列入应施检疫的植物、植物产品名单的；</p>
                <p>(2) 种子、苗木和其他繁殖材料。</p>
                <p>3、动物及动物产品：托运动物和动物产品时托运人认须提供检疫证明。</p>
                <p>4、不明物品类：不明液体或不明粉剂等。如白色粉沫。需要有出厂证明、货物的性状说明，必要时还应当提供生产技术部门出具的技术说明书。</p>
                <p>5、建筑垃圾：工程渣土、工程泥浆、工程垃圾、拆除垃圾等建筑垃圾。托运时必须有政府主管部门核发的建筑垃圾处置许可。</p>
                <p>6、托运下列货物发生泄露、污染其他货物的，或未尽到包装及/或告知义务，所产生的全部损失应全部由运输服务需求方承担：</p>
                <p>玻璃、实木家具、油漆、油墨、胶水、涂料、香精、泡水咸菜、袋装牛奶、电解液、蓄电池等易碎、易磨损、易泄漏、易燃、气味难闻，容易污染其它货物的货物。</p>
                <hr/>
                <div className="h1"><strong>附件：危险物品、禁运品标识</strong></div>
                <p>为便于您知晓、区分危险货物、禁运品，请您查看并识别以下标识：</p>
                <div className="pic">
                    <img src={logoImg} alt=""/>
                </div>
            </div>
        </div>
    </Modal>
}